import '../scss/sweetener-fy23.scss';

window.addEventListener('DOMContentLoaded', () => {
	var personaWrappers = document.querySelectorAll('.everyone > ul > li');
	var hasBeenOpened = {
		value: false,
		get: function () {
			return this.value;
		},
		set: function (value) {
			this.value = value;
			personaWrappers.forEach(function (wrapper) {
				if (value) {
					wrapper.classList.add('has-been-opened', value);
				} else {
					wrapper.classList.remove('has-been-opened', value);
				}
			});
		}
	};
	if (personaWrappers) {
		personaWrappers.forEach(function (wrapper) {
			var persona = wrapper.querySelector('.persona');
			var details = wrapper.querySelector('.persona__details');
			// var detailsButton = wrapper.querySelector('.persona > .button');
			persona.addEventListener('click', function (e) {
				// close others
				closeOthers(personaWrappers, persona);
				// toggle this one
				var expanded = persona.getAttribute('aria-expanded') === 'true';
				var indicator = persona.querySelector('.has-underline > span:last-of-type');
				persona.setAttribute('aria-expanded', !expanded);
				// detailsButton.style.display = expanded ? 'block' : 'none';
				indicator.textContent = expanded ? '+' : '-';
				details.hidden = expanded;
				if (!expanded) {
					hasBeenOpened.set(true);
				} else {
					hasBeenOpened.set(false);
				}
				console.log('hasBeenOpened', hasBeenOpened);
			});
		});
	}
	function closeOthers(personaWrappers, persona) {
		personaWrappers.forEach(function (wrapper) {
			var otherPersona = wrapper.querySelector('.persona');
			var otherDetails = wrapper.querySelector('.persona__details');
			// var detailsButton = wrapper.querySelector('.persona > .button');
			var indicator = wrapper.querySelector('.has-underline > span:last-of-type');
			if (otherPersona !== persona) {
				otherPersona.setAttribute('aria-expanded', false);
				otherDetails.hidden = true;
				// detailsButton.style.display = 'block';
				indicator.textContent = '+';
			}
		});

	}

	const floater = document.querySelector('.sweeteners-floater');
	console.log('floater', floater);
	const formSection = document.getElementById('rebate');
	let observer = new IntersectionObserver(callback, {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	})
	if (formSection) {
		observer.observe(formSection);
	}
	function callback (entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				floater.classList.add('floater-hide');
			} else {
				floater.classList.remove('floater-hide');
			}
		});
	}
});